export default "__VITE_ASSET__Dzxr90K5__"